// extracted by mini-css-extract-plugin
export default {"separator":"OwnOperationsItem_separator__bZOJX","archived":"OwnOperationsItem_archived__P+9L6","staticCell":"OwnOperationsItem_staticCell__q6FUF"};